module.exports = __webpack_public_path__ + "static/img/text_search@2x.a5e62293.png";